/* ===== BUMP IT — landing.js ===== */

// FAQ accordion
document.querySelectorAll('.lp-faq-q').forEach(function (btn) {
  btn.addEventListener('click', function () {
    var item = btn.closest('.lp-faq-item');
    var wasOpen = item.classList.contains('open');
    item.closest('.lp-faq').querySelectorAll('.lp-faq-item.open').forEach(function (openItem) {
      if (openItem !== item) openItem.classList.remove('open');
    });
    item.classList.toggle('open', !wasOpen);
  });
});

// Sticky mobile CTA — appare dopo l'hero
var stickyCta = document.querySelector('.lp-sticky-cta');
if (stickyCta) {
  var trigger = document.querySelector('.lp-hero, .lpc-hero');
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      stickyCta.classList.toggle('visible', !entry.isIntersecting);
    });
  }, { threshold: 0 });
  if (trigger) obs.observe(trigger);
}

// Swap demo — alterna automaticamente tra due skin sulla stessa cover
var swapImgs = document.querySelectorAll('.lp-swap-img');
var swapLabel = document.getElementById('lpSwapLabel');
if (swapImgs.length > 1) {
  var swapIdx = 0;
  setInterval(function () {
    swapImgs[swapIdx].classList.remove('active');
    swapIdx = (swapIdx + 1) % swapImgs.length;
    swapImgs[swapIdx].classList.add('active');
    if (swapLabel) swapLabel.textContent = swapImgs[swapIdx].dataset.label || '';
  }, 2200);
}

// Smooth scroll to configurator (landing configuratore)
document.querySelectorAll('[data-scroll-to]').forEach(function (el) {
  el.addEventListener('click', function (e) {
    var target = document.querySelector(el.dataset.scrollTo);
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
});
